import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"
import { format } from "date-fns";

/**
 * tailwind-merge는 `fontSize`의 커스텀 토큰(예: `text-caption`, `text-body`)을 자기 내장
 * font-size 스케일(xs/sm/base/lg/…)로 인식하지 못하면 `text-color` 그룹으로 오분류해,
 * `text-white text-caption`처럼 색+크기를 같이 쓰면 같은 그룹 충돌로 판단해 먼저 온 색
 * 클래스를 지워버린다(예: 네이비 배경 버튼의 흰 글자가 사라짐). tailwind.config.js의
 * fontSize 커스텀 키를 font-size 그룹에 등록해 색과 충돌하지 않도록 한다.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "display",
            "h1",
            "h2",
            "h3",
            "h4",
            "body-lg",
            "body",
            "body-sm",
            "caption-legacy",
            "heading-1",
            "heading-2",
            "heading-3",
            "label",
            "caption",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}



// 날짜 포맷 함수 (목록 페이지와 동일하게 사용 가능)
const localFormatDate = (dateString: string | null | undefined) => {
  if (!dateString) return "-";
  try {
    return format(new Date(dateString), 'yyyy-MM-dd HH:mm:ss');
  } catch (e) { return "-"; }
};

export { localFormatDate };